export const checkIfErrors = (propName: string, errors: any): boolean =>
  errors?.hasOwnProperty(propName);
export const helperText = (propName: string, errors: any): boolean | string =>
  checkIfErrors(propName, errors) && (errors as any)[propName].message;
